/**
 * Native Shopify storefront tracking
 * CACHE_BUST_2026_07_31_CAPI (Meta Pixel + CAPI best-practice payloads).
 * Purchase is NOT fired here — orders/paid webhook owns Meta/GA4/Omnisend purchase.
 *
 * Money convention: callers pass Shopify cents (integers). moneyValue() → dollars.
 * Catalog: content_ids use Shopify product IDs (matches Purchase webhook + Meta catalog).
 */
(function () {
  var cfg = window.TBP_TRACKING;
  if (!cfg) return;

  // No pixel id = another app owns Meta/analytics events (WeTracked). Keep only the
  // cart-attribute attribution (click ids + UTMs) so orders stay attributable.
  var ATTRIBUTION_ONLY = !cfg.metaPixelId;

  var STORAGE_FBCLID = 'tbp_fbclid';
  var STORAGE_GCLID = 'tbp_gclid';
  var STORAGE_EXT = 'tbp_external_id';
  var STORAGE_UTM = 'tbp_utm';
  var IC_DEDUPE_MS = 8000;
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function cookieGet(name) {
    try {
      var m = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
      );
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function cookieSet(name, value, days) {
    try {
      var maxAge = Math.floor((days || 90) * 86400);
      var secure = location.protocol === 'https:' ? '; Secure' : '';
      document.cookie =
        name +
        '=' +
        encodeURIComponent(value) +
        '; Max-Age=' +
        maxAge +
        '; Path=/; SameSite=Lax' +
        secure;
    } catch (e) {}
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'tbp_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
  }

  function eventId(prefix) {
    return prefix + '_' + uuid();
  }

  function readParam(key) {
    try {
      return new URLSearchParams(window.location.search).get(key);
    } catch (e) {
      return null;
    }
  }

  function persistClickIds() {
    var fbclid = readParam('fbclid');
    if (fbclid) {
      try {
        sessionStorage.setItem(STORAGE_FBCLID, fbclid);
      } catch (e) {}
      // Persist first-party _fbc so CAPI + cart attrs keep the click id after URL strips.
      if (!cookieGet('_fbc')) {
        cookieSet('_fbc', 'fb.1.' + Math.floor(Date.now() / 1000) + '.' + fbclid, 90);
      }
    }
    var gclid = readParam('gclid');
    if (gclid) {
      try {
        sessionStorage.setItem(STORAGE_GCLID, gclid);
      } catch (e) {}
    }
    ['gbraid', 'wbraid'].forEach(function (k) {
      var v = readParam(k);
      if (v) {
        try {
          sessionStorage.setItem('tbp_' + k, v);
        } catch (e) {}
      }
    });
  }

  function persistUtms() {
    var found = {};
    var any = false;
    UTM_KEYS.forEach(function (k) {
      var v = readParam(k);
      if (v) {
        found[k] = v;
        any = true;
      }
    });
    if (!any) return;
    try {
      var prev = {};
      try {
        prev = JSON.parse(sessionStorage.getItem(STORAGE_UTM) || '{}') || {};
      } catch (e) {}
      Object.keys(found).forEach(function (k) {
        prev[k] = found[k];
      });
      sessionStorage.setItem(STORAGE_UTM, JSON.stringify(prev));
    } catch (e) {}
  }

  function getStoredUtms() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_UTM) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function getFbclid() {
    var fromUrl = readParam('fbclid');
    if (fromUrl) return fromUrl;
    try {
      return sessionStorage.getItem(STORAGE_FBCLID);
    } catch (e) {
      return null;
    }
  }

  /**
   * Prefer logged-in Shopify customer id (matches pixel Advanced Matching).
   * Guests keep a stable UUID in cookie/localStorage (plaintext for pixel AM;
   * CAPI route SHA-256 hashes before Graph API).
   */
  function getExternalId() {
    if (cfg.customerExternalId) {
      var cid = String(cfg.customerExternalId);
      cookieSet('tbp_external_id', cid, 365);
      try {
        localStorage.setItem(STORAGE_EXT, cid);
      } catch (e) {}
      return cid;
    }

    var existing = cookieGet('tbp_external_id');
    if (existing) return existing;
    try {
      existing = localStorage.getItem(STORAGE_EXT);
    } catch (e) {}
    if (existing) {
      cookieSet('tbp_external_id', existing, 365);
      return existing;
    }
    var id = uuid();
    cookieSet('tbp_external_id', id, 365);
    try {
      localStorage.setItem(STORAGE_EXT, id);
    } catch (e) {}
    return id;
  }

  function getFbp() {
    return cookieGet('_fbp');
  }

  function getFbc() {
    var fbc = cookieGet('_fbc');
    if (fbc) return fbc;
    var fbclid = getFbclid();
    if (!fbclid) return null;
    var built = 'fb.1.' + Math.floor(Date.now() / 1000) + '.' + fbclid;
    cookieSet('_fbc', built, 90);
    return built;
  }

  /** Sync Advanced Matching so pixel + CAPI share external_id (and logged-in PII). */
  function syncPixelAdvancedMatching() {
    if (typeof window.fbq !== 'function') return;
    var am = {};
    var ext = getExternalId();
    if (ext) am.external_id = String(ext);
    if (cfg.customerEmail) am.em = String(cfg.customerEmail).trim().toLowerCase();
    if (cfg.customerPhone) {
      am.ph = String(cfg.customerPhone).replace(/\D/g, '');
    }
    if (cfg.customerFirstName) am.fn = String(cfg.customerFirstName).trim().toLowerCase();
    if (cfg.customerLastName) am.ln = String(cfg.customerLastName).trim().toLowerCase();
    if (!Object.keys(am).length) return;
    try {
      window.fbq('init', cfg.metaPixelId, am);
    } catch (e) {}
  }

  /**
   * Shopify storefront amounts are cents. Always convert to dollars for Meta/GA.
   * Pass unit:'dollars' only when the value is already decimal dollars.
   */
  function moneyValue(amount, unit) {
    if (amount == null || amount === '') return undefined;
    var n = Number(amount);
    if (!isFinite(n)) return undefined;
    if (unit === 'dollars') return Math.round(n * 100) / 100;
    // Default: cents → dollars
    return Math.round(n) / 100;
  }

  /** Prefer Shopify product id for Meta catalog / Purchase dedupe consistency. */
  function catalogContentId(item) {
    item = item || {};
    var productId = item.productId != null ? item.productId : item.id;
    if (productId != null && String(productId) !== '' && String(productId) !== 'undefined') {
      return String(productId);
    }
    if (item.variantId != null) return String(item.variantId);
    if (item.handle) return String(item.handle);
    return '';
  }

  function deliverCapi(payload) {
    if (!cfg.capiEndpoint) return Promise.resolve(false);
    return fetch(cfg.capiEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
      mode: 'cors',
      credentials: 'omit',
    })
      .then(function (r) {
        return r.ok;
      })
      .catch(function () {
        return false;
      });
  }

  function trackMeta(eventName, customData, idPrefix, extraUser, fixedEventId) {
    var eid = fixedEventId || eventId(idPrefix || 'evt');
    if (ATTRIBUTION_ONLY) return { eventId: eid, capiPromise: Promise.resolve(false) };
    var skipPixel = false;

    // Bootstrap already fired pixel PageView with an eventID — reuse it for CAPI dedupe.
    if (eventName === 'PageView' && window.__tbpMetaBootstrapPageView) {
      var bootId = window.__tbpMetaBootstrapPageView;
      window.__tbpMetaBootstrapPageView = 0;
      if (typeof bootId === 'string' && bootId) {
        eid = bootId;
        skipPixel = true;
      } else {
        // Legacy flag (1): skip duplicate pixel, but CAPI gets a fresh id.
        skipPixel = true;
      }
    }

    syncPixelAdvancedMatching();

    var eventTime = Math.floor(Date.now() / 1000);
    var user_data = {
      external_id: getExternalId(),
      fbp: getFbp() || undefined,
      fbc: getFbc() || undefined,
    };
    if (cfg.customerEmail) user_data.em = String(cfg.customerEmail).trim().toLowerCase();
    if (cfg.customerPhone) user_data.ph = String(cfg.customerPhone).replace(/\D/g, '');
    if (extraUser) {
      if (extraUser.em) user_data.em = extraUser.em;
      if (extraUser.ph) user_data.ph = extraUser.ph;
    }

    if (!skipPixel && typeof window.fbq === 'function') {
      window.fbq('track', eventName, customData || {}, { eventID: eid });
    }

    var capiPromise = deliverCapi({
      event_name: eventName,
      event_id: eid,
      event_time: eventTime,
      event_source_url: window.location.href,
      custom_data: customData || {},
      user_data: user_data,
    });

    return { eventId: eid, capiPromise: capiPromise };
  }

  function trackGtag(name, params) {
    if (ATTRIBUTION_ONLY) return;
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params || {});
    }
  }

  function trackOmnisend(name, props) {
    if (ATTRIBUTION_ONLY) return;
    try {
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['track', name, props || {}]);
    } catch (e) {}
  }

  function syncCartAttributes(extra) {
    var attrs = {
      _fbp: getFbp() || '',
      _fbc: getFbc() || '',
      _fbclid: getFbclid() || '',
      _external_id: getExternalId() || '',
    };
    try {
      attrs._gclid = readParam('gclid') || sessionStorage.getItem(STORAGE_GCLID) || '';
      attrs._gbraid = readParam('gbraid') || sessionStorage.getItem('tbp_gbraid') || '';
      attrs._wbraid = readParam('wbraid') || sessionStorage.getItem('tbp_wbraid') || '';
    } catch (e) {}

    var utms = getStoredUtms();
    UTM_KEYS.forEach(function (k) {
      var fromUrl = readParam(k);
      var v = fromUrl || utms[k] || '';
      if (v) attrs['_' + k] = v;
    });

    if (extra) {
      Object.keys(extra).forEach(function (k) {
        if (extra[k]) attrs[k] = extra[k];
      });
    }
    // Drop empties
    Object.keys(attrs).forEach(function (k) {
      if (!attrs[k]) delete attrs[k];
    });
    if (!Object.keys(attrs).length) return Promise.resolve();

    var updateUrl =
      (window.routes && window.routes.cart_update_url) || '/cart/update.js';
    return fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      credentials: 'same-origin',
      keepalive: true,
    }).catch(function () {});
  }

  function markIcSent(eid) {
    window.__tbpIcEventId = eid;
    window.__tbpIcSentAt = Date.now();
    try {
      sessionStorage.setItem('_meta_ic_event_id', eid);
      sessionStorage.setItem('_meta_ic_sent_at', String(window.__tbpIcSentAt));
    } catch (e) {}
  }

  function recentlySentIc() {
    var at = window.__tbpIcSentAt || 0;
    try {
      at = at || Number(sessionStorage.getItem('_meta_ic_sent_at') || 0);
    } catch (e) {}
    return at && Date.now() - at < IC_DEDUPE_MS;
  }

  function fetchCartSnapshot() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    if (cartUrl.indexOf('.js') === -1) cartUrl = cartUrl.replace(/\/$/, '') + '.js';
    return fetch(cartUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return null;
      });
  }

  function icOptsFromCart(cart, overrides) {
    overrides = overrides || {};
    if (!cart) return overrides;
    var items = cart.items || [];
    var contentIds = [];
    var contents = [];
    items.forEach(function (li) {
      var id = String(li.product_id || li.productId || '');
      if (!id) id = String(li.variant_id || li.id || '');
      if (!id) return;
      if (contentIds.indexOf(id) === -1) contentIds.push(id);
      var linePrice = moneyValue(li.final_price != null ? li.final_price : li.price, 'cents');
      contents.push({
        id: id,
        quantity: li.quantity || 1,
        item_price: linePrice,
      });
    });
    var numItems = items.reduce(function (n, li) {
      return n + (li.quantity || 0);
    }, 0);
    return {
      value: cart.total_price,
      numItems: numItems || overrides.numItems || 1,
      contentIds: contentIds.length ? contentIds : overrides.contentIds || [],
      contents: contents.length ? contents : overrides.contents || [],
      unit: 'cents',
    };
  }

  // Public API for PDP / cart
  window.TBP = window.TBP || {};

  window.TBP.moneyValue = moneyValue;

  window.TBP.trackViewContent = function (item) {
    item = item || cfg.product || {};
    var unit = item.unit || (item.priceDollars != null ? 'dollars' : 'cents');
    var raw = item.priceDollars != null ? item.priceDollars : item.price;
    var value = moneyValue(raw, unit);
    var contentId = catalogContentId(item);
    var custom = {
      content_ids: contentId ? [contentId] : [],
      content_type: 'product',
      content_name: item.title || undefined,
      value: value,
      currency: cfg.currency || 'USD',
      contents: contentId
        ? [{ id: contentId, quantity: 1, item_price: value }]
        : [],
    };
    trackMeta('ViewContent', custom, 'vc');
    trackGtag('view_item', {
      currency: custom.currency,
      value: value,
      items: [
        {
          item_id: contentId || String(item.variantId || ''),
          item_name: item.title || '',
        },
      ],
    });
  };

  window.TBP.trackAddToCart = function (item) {
    item = item || {};
    var unit = item.unit || (item.priceDollars != null ? 'dollars' : 'cents');
    var raw = item.priceDollars != null ? item.priceDollars : item.price;
    var value = moneyValue(raw, unit);
    var contentId = catalogContentId(item);
    var qty = item.quantity || 1;
    var custom = {
      content_ids: contentId ? [contentId] : [],
      content_type: 'product',
      content_name: item.title || undefined,
      value: value,
      currency: cfg.currency || 'USD',
      contents: contentId
        ? [
            {
              id: contentId,
              quantity: qty,
              item_price: value,
            },
          ]
        : [],
    };
    trackMeta('AddToCart', custom, 'atc');
    trackGtag('add_to_cart', {
      currency: custom.currency,
      value: value,
      items: [
        {
          item_id: contentId || String(item.variantId || ''),
          item_name: item.title || '',
          quantity: qty,
        },
      ],
    });
    trackOmnisend('added product to cart', {
      productID: contentId || String(item.id || ''),
      productVariantID: String(item.variantId || ''),
      productTitle: item.title || '',
      productPrice: value,
      currency: custom.currency,
    });
    syncCartAttributes();
  };

  /**
   * Fire InitiateCheckout (pixel + CAPI) and persist event id on the cart.
   * Returns a Promise that resolves after CAPI + cart attribute sync (best-effort).
   */
  window.TBP.trackInitiateCheckout = function (opts) {
    opts = opts || {};
    if (opts.dedupe !== false && recentlySentIc()) {
      return Promise.resolve(window.__tbpIcEventId || null);
    }

    var unit = opts.unit || 'cents';
    var value = moneyValue(opts.value, unit);
    var contentIds = opts.contentIds || [];
    var contents = opts.contents || [];
    if ((!contents || !contents.length) && contentIds.length) {
      contents = contentIds.map(function (id) {
        return { id: String(id), quantity: 1 };
      });
    }
    var custom = {
      value: value,
      currency: cfg.currency || 'USD',
      num_items: opts.numItems || 1,
      content_ids: contentIds,
      content_type: 'product',
      contents: contents,
    };
    var tracked = trackMeta('InitiateCheckout', custom, 'ic');
    var eid = tracked.eventId;
    markIcSent(eid);

    trackGtag('begin_checkout', {
      currency: custom.currency,
      value: value,
    });
    trackOmnisend('started checkout', {
      value: value,
      currency: custom.currency,
    });

    var syncPromise = syncCartAttributes({ _meta_ic_event_id: eid });
    return Promise.all([tracked.capiPromise, syncPromise])
      .then(function () {
        return eid;
      })
      .catch(function () {
        return eid;
      });
  };

  /** Build IC from /cart.js then track — used by drawer checkout + goToCheckout. */
  window.TBP.prepareAndTrackCheckout = function (overrides) {
    overrides = overrides || {};
    if (overrides.dedupe !== false && recentlySentIc()) {
      return Promise.resolve(window.__tbpIcEventId || null);
    }
    return fetchCartSnapshot().then(function (cart) {
      var ic = icOptsFromCart(cart, overrides);
      return window.TBP.trackInitiateCheckout(ic);
    });
  };

  window.TBP.syncCartAttributes = syncCartAttributes;
  window.TBP.recentlySentIc = recentlySentIc;

  persistClickIds();
  persistUtms();
  getExternalId();
  syncPixelAdvancedMatching();

  // PageView CAPI (pixel already fired in bootstrap)
  trackMeta('PageView', {}, 'pageview');
  syncCartAttributes();

  if (cfg.pageType === 'product' && cfg.product) {
    window.TBP.trackViewContent(cfg.product);
  }

  // Checkout links + cart-drawer Checkout button → InitiateCheckout (with cart totals).
  // Skip if Buy Now / goToCheckout already fired IC moments ago.
  // For the drawer button, block submit until IC + cart attrs finish (avoids lost events).
  document.addEventListener(
    'click',
    function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/checkout"]') : null;
      var checkoutBtn =
        e.target && e.target.closest
          ? e.target.closest('#CartDrawer-Checkout, [name="checkout"], button[form="CartDrawer-Form"]')
          : null;
      if (!a && !checkoutBtn) return;
      if (recentlySentIc()) return;

      // Drawer / form checkout: await tracking, then submit/navigate.
      if (checkoutBtn) {
        if (checkoutBtn.disabled) return;
        e.preventDefault();
        e.stopPropagation();
        if (checkoutBtn.dataset.tbpIcPending === '1') return;
        checkoutBtn.dataset.tbpIcPending = '1';
        window.TBP.prepareAndTrackCheckout({})
          .catch(function () {})
          .then(function () {
            checkoutBtn.dataset.tbpIcPending = '';
            // Don't form.submit() — that drops name=checkout and won't enter checkout.
            if (window.TBP && typeof window.TBP.goToCheckout === 'function') {
              return window.TBP.goToCheckout({ track: false });
            }
            window.location.href = '/checkout';
          });
        return;
      }

      // Plain checkout <a> — fire-and-forget (navigation may race; Buy Now uses goToCheckout await).
      window.TBP.prepareAndTrackCheckout({});
    },
    true
  );

  // Dawn cart:refresh after ATC elsewhere
  document.addEventListener('cart:refresh', function () {
    syncCartAttributes();
  });
})();
